import React, { useEffect, useState } from 'react';
import { AdvancedMarker, APIProvider, Map, MapEvent } from '@vis.gl/react-google-maps';
import ENV from '~/environment';
import Radius from './Radius';

const containerStyle = {
  width: '100%',
  height: '400px',
  borderRadius: '5px',
  border: '1px solid rgba(34,36,38,.15)'
}

export type CoordType = {
  lat: number,
  lng: number
}

interface Props extends CoordType {
  radius?: number,
  handleChangeMarkerPosition?: (data: CoordType) => void
  disableGestures?: boolean
  zoomLevel?: number
}

const GoogleMap: React.FC<Props> = (props) => {
  const { zoomLevel, disableGestures, handleChangeMarkerPosition } = props

  const [markerPosition, setMarkerPosition] = useState<CoordType>({ lat: props.lat, lng: props.lng })
  const [radius, setRadius] = useState(props.radius || 10)

  useEffect(() => {
    setMarkerPosition({ lat: props.lat, lng: props.lng })
    if(props.radius) {
      setRadius(props.radius)
    }
  }, [props])

  return <APIProvider apiKey={ENV.GOOGLE_API_KEY}>
    <Map
      defaultCenter={markerPosition}
      center={markerPosition}
      defaultZoom={zoomLevel || 8}
      mapId='fishing-app'
      gestureHandling={disableGestures ? 'none' : 'greedy'}
      style={containerStyle}
      onClick={(event: MapEvent) => {
        if(handleChangeMarkerPosition) {
          handleChangeMarkerPosition({
          //@ts-ignore
            lat: event.detail?.latLng?.lat,
            //@ts-ignore
            lng: event.detail?.latLng?.lng
          })
        }
      }}
      disableDefaultUI
    >
      {props.radius && <Radius
        radius={radius}
        position={markerPosition}
        handleChangeMarkerPosition={handleChangeMarkerPosition}
      />}
      <AdvancedMarker
        position={markerPosition}
        key={Math.random()}
      />
    </Map>
  </APIProvider>
}
export default GoogleMap